// AJAX CART

//DOM ELEMENTS

// Add To Cart Form - used throughout website so will work for all.
const addToCartForm = document.querySelectorAll('#product-form');

// Add To Cart Form Upsells - used throughout website so will work for all.
const addonForm = document.querySelectorAll('#addon-form');

//Slide Cart Wrapper
const slideCartWrapper = document.querySelector('.slide-cart-wrapper');

addToCartForm.forEach((form) => {
  form.addEventListener("submit", async (e) => {
      e.preventDefault();

      loadSpinner();
      document.getElementById('addToCartButton').textContent = "ADDING...";

      // Submit the form with AJAX
      await fetch("/cart/add", {
          method: "POST",
          body: new FormData(form),
      });

      //Update Cart Count Header
        updateHeaderCartCount();
      
      // Update Slide Cart
        updateSlideCart();

      // Close Spinner
        closeSpinner();

      // Open
        openSlideCart();

      // Rename Button
      document.getElementById('addToCartButton').textContent = "ADD TO CART";

  });
});

// Open
function openSlideCart() {
  slideCartWrapper.classList.add("slide-cart--active");
  document.body.style.overflowY = "hidden";
}

// Close
function closeSlideCart () {
  slideCartWrapper.classList.remove("slide-cart--active");
  document.body.style.overflowY = "scroll";
}

// Update Cart Count in Header
async function updateHeaderCartCount() {
    // Get New Cart Object
    const res = await fetch("/cart.json");
    const cart = await res.json();

    document.querySelectorAll(".header-cart-item-count .number-circle").forEach(el => {
        el.textContent = cart.item_count;
    });
}

// Slide Cart Listeners

async function slideCartListeners() {

      // Update Quantity Input
      document.querySelectorAll('.slide-cart-quantity-selector button').forEach((button) => {
          button.addEventListener('click', async () => {

      // Get Line item Key
      const rootLineItem = button.closest("#slide-cart-item").getAttribute("slide-cart-line-item-key");

      // Get Original Item Invventory for Stock Checking
      let originalItemInventory = document.querySelector(".slide-cart-quantity-selector").getAttribute("inventory-quantity");

      // Error Messge Max QTY Reached
      // const maxQTY = document.querySelector(".item-qty-max-reached");

      // Get New Quantity to Check Inventory

      const currentQty = Number(button.parentElement.querySelector('input[name="updates[]"]').value);

      const isUp = button.classList.contains('slide-cart-quantity-selector-plus');

      const newQty = isUp ? currentQty + 1 : currentQty - 1;

          // maxQTY.style.display ="none";
            //Load Spinner
            loadSpinnerSlideCart();
      // Update QTY with AJAX
          const res = await fetch('/cart/update.js', {
          method: "POST",
          headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [rootLineItem]: newQty } }),
      });
      
      // Load SLide Cart Spinner
        loadSpinnerSlideCart();

      // Update Slide Cart
        updateSlideCart();

      // Update Header Cart Count
        updateHeaderCartCount();

      // Close Spinner
         closeSpinnerSlideCart();


});

    
      async function removeItem(key, quantity, item) {
        loadSpinnerSlideCart();
                // REmove with AJAX
                const res = await fetch('/cart/update.js', {
                method: "POST",
                headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                },
                body: JSON.stringify({ updates: { [key]: quantity } }),
            });
            const cart = await res.json();
            
            if (cart.items.length === 0) {
              closeSpinnerSlideCart();
              closeSlideCart();
              updateHeaderCartCount();
    
            } else {
              closeSpinnerSlideCart();
              updateHeaderCartCount();
              const format = document.querySelector('[data-money-format]').getAttribute('data-money-format');
              const totalPrice = formatMoney(cart.total_price, format);
              document.querySelector("#template-cart-total-price").textContent = totalPrice;
              item.remove();
            }
      }

        
      // Remove Product
      document.querySelectorAll(".slide-cart-remove").forEach((remove) => {
        remove.addEventListener("click", (e) => {
          e.preventDefault();

          const item = remove.closest(".slide-cart-item");
          const key = item.getAttribute('slide-cart-line-item-key');
          removeItem(key, 0, item);

          // Update Slide Cart
        updateSlideCart();
    
        });
      });

  });


  // Stop Inner Slide Cart closing cart
  document.querySelector(".slide-cart-inner-wrapper").addEventListener("click", (e) => {
      e.stopPropagation();
  });

  // Close Slide Cart
  document.querySelectorAll(".slide-cart-close, .slide-cart-wrapper").forEach((close) => {
      close.addEventListener("click", () => {
          closeSlideCart();
      });
  });

}

slideCartListeners();

// Open Slide Cart
document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
      e.preventDefault();
      openSlideCart();
  })
})

// Update Slide Cart Inner Item HTML
async function updateSlideCart() {
    const res = await fetch("slide-cart-wrapper");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    const newItems = html.querySelector(".slide-cart-wrapper").innerHTML;
    slideCartWrapper.innerHTML = newItems;
    // console.log(newItems);
    slideCartListeners();
    addOn();
}


async function loadSpinner() {
    document.querySelector(".loader").style.display = "block";
    document.querySelector(".loader-wrapper").style.backgroundColor = "rgba(0, 0, 0, 0.7)";
}

async function closeSpinner() {
    document.querySelector(".loader").style.display = "none";
}

async function loadSpinnerSlideCart() {
    document.querySelector(".loader-slide-cart").style.display = "block";
    document.querySelector(".loader-wrapper-slide-cart").style.backgroundColor = "rgba(0, 0, 0, 0.7)";
}

async function closeSpinnerSlideCart() {
    document.querySelector(".loader-slide-cart").style.display = "none";
}


// Add-On Form - used throughout website so will work for all.
addOn();

// Addon Form Submit (within slide out cart)
function addOn() {
    const addonForm = document.querySelectorAll('#addon-form');
  
    // Addon Form Submit (within slide out cart)
    
    addonForm.forEach((form) => {
        form.addEventListener("submit", async (e) => {
            e.preventDefault();
            loadSpinnerSlideCart();
      
            form.querySelector('#addon-btn').textContent = "ADDING...";
      
            // Submit the form with AJAX
            await fetch("/cart/add", {
                method: "POST",
                body: new FormData(form),
            });
      
            // Get New Cart Object
            const res = await fetch("/cart.json");
            const cart = await res.json();
      
            //Update Cart Count Header
            document.querySelectorAll(".header-cart-item-count .number-circle").forEach(el => {
                el.textContent = cart.item_count;
            })

            closeSpinnerSlideCart();
            
            // Update Slide Cart
             updateSlideCart();

            // Open
            openSlideCart();
      
            // Rename Button
            form.querySelector('#addon-btn').textContent = "ADD TO CART";
      
        });
    });
  }



  // Add-On Form - used throughout website so will work for all.
addOnBundles();

// Addon Form Submit (within slide out cart)
function addOnBundles() {
    const addonForm = document.querySelectorAll('#addon-form-bundles');
  
    // Addon Form Submit (within slide out cart)
    
    addonForm.forEach((form) => {
        form.addEventListener("submit", async (e) => {
            e.preventDefault();
            loadSpinnerSlideCart();
      
            form.querySelector('#addon-btn').textContent = "ADDED";
      
            // Submit the form with AJAX
            await fetch("/cart/add", {
                method: "POST",
                body: new FormData(form),
            });
      
            // Get New Cart Object
            const res = await fetch("/cart.json");
            const cart = await res.json();
      
            //Update Cart Count Header
            document.querySelectorAll(".header-cart-item-count .number-circle").forEach(el => {
                el.textContent = cart.item_count;
            })

            closeSpinnerSlideCart();
            
            // Update Slide Cart
             updateSlideCart();

            // Open
            // openSlideCart();

            // Display Message
            // form.querySelector('.added-to-cart').classList.add('active');
      
            // Rename Button
            form.querySelector('#addon-btn').textContent = "ADD TO BUNDLE";
      
        });
    });
  }






// Add-On Form UPSELLS CART
addOnCart();

  // Addon Form Submit (within slide out cart)
function addOnCart() {
  const addonForm = document.querySelectorAll('#addon-form-cart');

  // Addon Form Submit (within slide out cart)
  
  addonForm.forEach((form) => {
      form.addEventListener("submit", async (e) => {
          e.preventDefault();
          loadSpinnerSlideCart();
    
          form.querySelector('#addon-btn').textContent = "ADDING...";
    
          // Submit the form with AJAX
          await fetch("/cart/add", {
              method: "POST",
              body: new FormData(form),
          });
    
          // Get New Cart Object
          const res = await fetch("/cart.json");
          const cart = await res.json();
    
          //Update Cart Count Header
          document.querySelectorAll(".header-cart-item-count .number-circle").forEach(el => {
              el.textContent = cart.item_count;
          })

          closeSpinnerSlideCart();
          
          // Update Slide Cart
           updateSlideCart();

          // Open
          openSlideCart();
    
          // Rename Button
          form.querySelector('#addon-btn').textContent = "ADD TO CART";
    
      });
  });
}


  // Format Monies

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};